import React from 'react'
import clsx from 'clsx'
import { StaticImage } from 'gatsby-plugin-image'

import * as styles from './PressCoverage.module.css'

export default function PressCoverage() {
  return (
    <>
      <div className="et_pb_row">
        <div className="et_pb_column et_pb_column_4_4">
          <div className="et_pb_text et_pb_bg_layout_light et_pb_text_align_center">
            <h2>As Seen In:</h2>
          </div>
        </div>
      </div>
      <div className="et_pb_row">
        <div className="et_pb_column et_pb_column_1_4">
          <StaticImage
            src="../../images/press/investor-chronicle-logo.jpg"
            alt="Investor Chronicle"
            className="et-waypoint et_pb_image et_pb_animation_off"
            width={300}
            objectFit="contain"
          />
        </div>
        <div className="et_pb_column et_pb_column_3_4">
          <div className="et_pb_testimonial">
            <p>
              An online trawl revealed a host of cheap options including sample
              wills which can be filled in and downloaded, but I felt I needed a
              little more guidance than a simple downloadable form. I plumped
              for Affio, an online service that offers to hold your hand through
              the process of compiling a will including useful video guides on
              each section – how to choose executors or trustees and guardians
              for my children. Each part of the will was broken down into easily
              manageable tasks, which made the whole process pretty painless –
              less than an hour later I had downloaded my will and had it signed
              by witnesses and was wondering why I had put it off for so long.
            </p>
            <p className="et_pb_testimonial_author">
              — Graeme Davies - Investors Chronicle
            </p>
          </div>
        </div>
      </div>
      <div className="et_pb_row">
        <div className="et_pb_column et_pb_column_4_4">
          <div
            className={clsx(
              'et_pb_text et_pb_bg_layout_light',
              styles.pressLogos,
            )}
          >
            <StaticImage
              src="../../images/press/daily-mail-logo.jpg"
              alt="Daily Mail"
              className={styles.pressLogosImage}
              width={195}
              objectFit="none"
            />
            <StaticImage
              src="../../images/press/express-logo.png"
              alt="Express"
              className={styles.pressLogosImage}
              width={195}
              objectFit="none"
            />
            <StaticImage
              src="../../images/press/sun-on-sunday-logo.png"
              alt="Sun on Sunday"
              className={styles.pressLogosImage}
              width={195}
              objectFit="none"
            />
            <StaticImage
              src="../../images/press/the-guardian-logo.png"
              alt="The Guardian"
              className={styles.pressLogosImage}
              width={195}
              objectFit="none"
            />
            <StaticImage
              src="../../images/press/web-user-logo.png"
              alt="Web User Magazine"
              className={styles.pressLogosImage}
              width={195}
              objectFit="none"
            />
          </div>
        </div>
      </div>
    </>
  )
}
